export default {
  placeholder: 'Beladungsplan auswählen',
};
